document.addEventListener("DOMContentLoaded", function () {
    function updateReviewNumber() {
        let reviewElement = document.querySelector(".media-object-section.main_review_stars div[style*='text-align: left']");
        if (reviewElement && !reviewElement.dataset.updated) {
            reviewElement.innerHTML = "&nbsp; From 2782 reviews"; // Change this number
            reviewElement.dataset.updated = "true"; // Prevent multiple updates
        }
    }

    function convertToPercentage() {
        let ratingElements = document.querySelectorAll(".total_reviews_number_Rating .box_rating_number");

        if (!ratingElements.length) return; // Exit if no rating elements found

        let ratings = Array.from(ratingElements).map(el => parseInt(el.textContent.trim()) || 0);
        let totalReviews = ratings.reduce((sum, num) => sum + num, 0);

        if (totalReviews > 0) {
            ratingElements.forEach((el, index) => {
                let ratingCount = ratings[index];
                let percentage = Math.round((ratingCount / totalReviews) * 100); // Round to whole number
                if (el.textContent !== `${percentage}%`) {
                    el.textContent = `${percentage}%`; // Update only if changed
                }
            });
        }
    }

    // Function to handle observer updates efficiently
    function handleMutations() {
        observer.disconnect(); // Temporarily disable observer
        updateReviewNumber();
        convertToPercentage();
        observer.observe(document.body, { childList: true, subtree: true }); // Re-enable observer
    }

    // Run once on page load
    updateReviewNumber();
    convertToPercentage();

    // Optimize observer with debounce to prevent excessive triggering
    let debounceTimer;
    let observer = new MutationObserver(() => {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(handleMutations, 300); // 300ms debounce
    });

    observer.observe(document.body, { childList: true, subtree: true });
});
